/* tslint:disable */
/* eslint-disable */
/**
 * Swagger
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @interface UpdateTranslationsDataRequest
 */
export class UpdateTranslationsDataRequest {
    /**
     *
     * @type {{ [key: string]: string; }}
     * @memberof UpdateTranslationsDataRequest
     */
    fileRows: { [key: string]: string };
    /**
     *
     * @type {string}
     * @memberof UpdateTranslationsDataRequest
     */
    lang: string;
    /**
     *
     * @type {string}
     * @memberof UpdateTranslationsDataRequest
     */
    fileName: string;
    /**
     *
     * @type {string}
     * @memberof UpdateTranslationsDataRequest
     */
    project: UpdateTranslationsDataRequestProjectEnum;
}

/**
 * @export
 * @enum {string}
 */
export enum UpdateTranslationsDataRequestProjectEnum {
    Cz = 'cz',
    Wt = 'wt',
    Et = 'et',
    EtProp = 'et-prop',
    Prop = 'prop',
    Crypto = 'crypto',
}
